export const isStudent = (roles) => roles?.includes('student')
export const isStaff = (roles) =>
  roles.includes('monk') || roles.includes('staff')
export const isAdmin = (roles) => roles.includes('admin')
